export default __webpack_public_path__ + "static/media/pdf-icon.cdc9516b.png";